import React from 'react';

export const ExternalComponentWrapper = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div id="search-app" className={className ? `w-full ${className}` : 'w-full'}>
    {children}
  </div>
);
